import {
  Button,
  Col,
  Divider,
  Drawer,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
  Upload,
  message,
} from "antd"
import React, { useEffect, useState } from "react"
import { InboxOutlined, PlusCircleOutlined } from "@ant-design/icons"
import { storage } from "../../../firebase/config"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

const { Text } = Typography
const { Option } = Select
const { TextArea } = Input
export default function OrderKnife({
  setIsModalOpen,
  setLabelWidth,
  setLabelHeight,
  setKniveSpaceBetweenRows,
  setKniveGapRaport,
  setKnifePrice,
  setNewKnife,
  setKniveButtonText,
  setKnifeShape,
  knifeShape,
  newKnifeMessage,
  setNewKnifeMessage,
  newKnifeRadiuss,
  setNewKnifeRadius,
  setNewKnifeFile,
}) {
  const [open, setOpen] = useState(false)

  //calculation parameters
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)
  const [shape, setShape] = useState("0")
  const [price, setPrice] = useState(0)
  const [spaceBetweenRows, setSpaceBetweenRows] = useState(3)
  const [gapRaport, setGapRaport] = useState(3)
  const [selectedFile, setSelectedFile] = useState(null) // Add this state

  const [buttonLoading, setButtonLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (price === 0) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [price])

  //button for order
  const orderButton = async () => {
    setButtonLoading(true)
    if (selectedFile) {
      const fileRef = ref(storage, `newKnifeShapes/${selectedFile.name}`)

      // Upload the file to Firebase Storage
      try {
        const snapshot = await uploadBytes(fileRef, selectedFile)
        console.log("Uploaded a file!")

        // Once the file is uploaded, retrieve its download URL
        const downloadURL = await getDownloadURL(snapshot.ref)
        console.log("File available at", downloadURL)

        // Set the file URL to your component's state
        setNewKnifeFile(downloadURL)
      } catch (error) {
        console.error("Upload failed", error)
        message.error("Upload failed: " + error.message)
      } finally {
        setLabelWidth(width)
        setLabelHeight(height)
        setKniveSpaceBetweenRows(spaceBetweenRows)
        setKniveGapRaport(gapRaport)
        setKnifePrice(price)
        setNewKnife(true)
        setKniveButtonText("New Knife...")
        setOpen(false)
        setIsModalOpen(false)
        setButtonLoading(false)
      }
    } else {
      setLabelWidth(width)
      setLabelHeight(height)
      setKniveSpaceBetweenRows(spaceBetweenRows)
      setKniveGapRaport(gapRaport)
      setKnifePrice(price)
      setNewKnife(true)
      setKniveButtonText("New Knife...")
      setOpen(false)
      setIsModalOpen(false)
      setButtonLoading(false)
    }
  }

  //calculation
  const calculatesSalePrice = () => {
    let widthLimit = 320
    let heightLimit = 444.5
    let priceFormula = 0.00156

    let maxHF = Math.floor(widthLimit / width)
    let maxVF = Math.floor(heightLimit / height)

    let calculateArea = width * height

    let areaX = calculateArea
    let areaY = maxHF
    let areaHorizontally = areaX * areaY

    let totalAreaX = areaHorizontally
    let totalAreaY = maxVF
    let die_Cut_Area = totalAreaX * totalAreaY

    let integerX = die_Cut_Area
    let totalPrice = integerX * priceFormula

    console.log(shape)
    if (shape === "1" || shape === "2") {
      if (totalPrice > 0 && totalPrice <= 105) {
        setPrice(75)
      } else if (totalPrice >= 105.01 && totalPrice <= 125) {
        setPrice(95)
      } else if (totalPrice >= 125.01 && totalPrice <= 155) {
        setPrice(125)
      }
    } else if (shape === "0") {
      // Handle the case where no shape is selected
      setPrice(0)
    } else {
      setPrice(Number(totalPrice.toFixed(2)))
    }
  }

  const handleWidthChange = (event) => {
    setWidth(event.target.value)
    setPrice(0)
  }

  const handleHeightChange = (event) => {
    setHeight(event.target.value)
    setPrice(0)
  }
  const handleSpaceBetweenRowsChange = (event) => {
    setSpaceBetweenRows(event.target.value)
    setPrice(0)
  }

  const handleGapRaportChange = (event) => {
    setGapRaport(event.target.value)
    setPrice(0)
  }

  const handleShapeChange = (value) => {
    setShape(value)
    setPrice(0)
    console.log(value)
    setKnifeShape(value)
    setNewKnifeRadius(0)
  }

  const handleSelectRadius = (value) => {
    setNewKnifeRadius(value)
  }

  const beforeUpload = (file) => {
    const fileUrl = URL.createObjectURL(file)
    setSelectedFile(fileUrl)

    // Prevent the file from being uploaded since we're handling it manually
    return false
  }

  return (
    <div>
      <Button type="primary" onClick={showDrawer} icon={<PlusCircleOutlined />}>
        Calculate a new Knife
      </Button>
      <Drawer
        title="Price for New Knife"
        placement="right"
        width={500}
        onClose={onClose}
        open={open}>
        <Row gutter={[10, 10]} align="middle">
          <Col span={8}>
            <Text>Select Shape :</Text>
          </Col>
          <Col span={16}>
            <Select style={{ width: "100%" }} value={knifeShape} onChange={handleShapeChange}>
              <Option value="none">none</Option>
              <Option value="Rectangle">Rectangle</Option>
              <Option value="Circle">Circle</Option>
              <Option value="Irregular Shape">Irregular Shape</Option>
            </Select>
          </Col>
          <Col span={8}>
            <Text>Width :</Text>
          </Col>
          <Col span={16}>
            <Input type="number" placeholder="Width" value={width} onChange={handleWidthChange} />
          </Col>
          <Col span={8}>
            <Text>Row Gap</Text>
          </Col>
          <Col span={16}>
            <Input
              type="number"
              placeholder="Row Gap"
              value={spaceBetweenRows}
              onChange={handleSpaceBetweenRowsChange}
            />
          </Col>
          <Col span={8}>
            <Text>Height :</Text>
          </Col>
          <Col span={16}>
            <Input
              type="number"
              placeholder="Height"
              value={height}
              onChange={handleHeightChange}
            />
          </Col>
          <Col span={8}>
            <Text>Gap Raport :</Text>
          </Col>
          <Col span={16}>
            <Input
              type="number"
              placeholder="Gap Raport"
              value={gapRaport}
              onChange={handleGapRaportChange}
            />
          </Col>
          <Col span={8}>
            <Text>Radius :</Text>
          </Col>
          <Col span={16}>
            <InputNumber
              placeholder="Radius"
              value={newKnifeRadiuss}
              style={{ width: "100%" }}
              onChange={handleSelectRadius}
            />
          </Col>
          <Col span={8}>
            <Text>Message :</Text>
          </Col>
          <Col span={16}>
            <TextArea
              placeholder="Your message"
              value={newKnifeMessage}
              rows={3}
              onChange={(event) => setNewKnifeMessage(event.target.value)}
            />
          </Col>
          <Col span={8}>
            <Text>File :</Text>
          </Col>
          <Col span={16}>
            <Upload beforeUpload={beforeUpload} maxCount={1}>
              <Button icon={<InboxOutlined />}>Click to Upload</Button>
            </Upload>
          </Col>
          <Col span={8}>
            <Text>Price :</Text>
          </Col>
          <Col span={16}>
            <Input type="number" placeholder="Price" value={price} />
          </Col>
          <Divider />
          <Col span={12}>
            <Button block danger type="primary" onClick={calculatesSalePrice}>
              Calculate
            </Button>
          </Col>

          <Col span={12}>
            <Button
              loading={buttonLoading}
              disabled={disabled}
              block
              type="primary"
              onClick={orderButton}>
              Confirm
            </Button>
          </Col>
        </Row>
      </Drawer>
    </div>
  )
}
